<app-sales-credit-number [creditNumber]="data().number" [data]="data()" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>
<div class="container section__productCategories h-full">
    <div class="wrapper">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article class="align__top big__padBot">
          <div class="mainInfo pb-25">
            <h1>Elige tu categoría</h1>
          </div>

          <div class="productCategoriesBox__view pb-12">
            <div class="productCategoriesBox__viewBtn" (click)="toggleView()">
              <i [ngClass]="isListView ? 'pi pi-th-large' : 'pi pi-bars'"></i>
              <span>
                {{ isListView ? 'Vista de cuadrículas' : 'Vista de lista' }}
              </span>
            </div>
          </div>

          <div class="productCategoriesBox productCategoriesBox--layout" [ngClass]="{ 'listView': isListView }">
            <div class="productCategoriesBox__content">
              <div class="productCategoriesBox__item" *ngFor="let category of categories()">
                <div class="productCategoriesBox__itemCont" (click)="save(category)">
                  <div class="background">
                    <div class="background__lines">
                      <app-background-lines></app-background-lines>
                    </div>
                    <div class="background__cross">
                      <app-background-crosses></app-background-crosses>
                    </div>
                  </div>
                  <div class="backgroundImage">
                  </div>
                  <div class="image">
                    <img [src]="category.image_url" [alt]="category.name" />
                  </div>
                  <div class="title">
                    <div class="title__ghost"><span>{{ category.name }}</span></div>
                    <h3>{{ category.name }}</h3>
                  </div>
                  <div class="btn">
                    <button pButton pRipple label="Seleccionar" class="p-button-secondary p-button-raised p-button-rounded w-full n-border" (click)="save(category)"></button>
                  </div>
                  <div class="arrow">
                    <i class="pi pi-angle-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>

 <app-sales-navigation-bar [activeStepCategories]="path" [selectedCategory]="selectedCategory" (gotoStepEventNavigator)="onGotoStep($event)"></app-sales-navigation-bar>
